const React = require("react");
const DashboardBlockTitle = require("../DashboardBlockTitle");
const DashboardBlock = require("../DashboardBlock");

const RetailerStatsValue = require('./components/RetailerStatsValue');

module.exports = ({retailersAdded, retailersActive}) => (
  <DashboardBlock>
    <DashboardBlockTitle>
      Retailer stats
    </DashboardBlockTitle>
    <div className="layoutRow mt6 mh-11 (w50%|ph11)>1">
      <div>
        <RetailerStatsValue
          label="Retailers added"
          value={retailersAdded}
        />
      </div>
      <div>
        <RetailerStatsValue
          label="Retailers active"
          value={retailersActive}
        />
      </div>
    </div>
  </DashboardBlock>
)